export const money = value => new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(Number(value))
export function monthYear(value) {
  const match = String(value || '').match(/^(\d{4})-(\d{2})/)
  if (!match || Number(match[1]) === 0 || Number(match[2]) < 1 || Number(match[2]) > 12) return '—'
  const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
  return `${months[Number(match[2]) - 1]} ${match[1]}`
}
export function date(value) {
  if (!value || String(value).startsWith('0000')) return '—'
  const parsed = typeof value === 'number' ? new Date(value * 1000) : new Date(String(value).slice(0, 10) + 'T12:00:00')
  return Number.isNaN(parsed.getTime()) ? '—' : parsed.toLocaleDateString('ru-RU')
}
